import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { firstValueFrom, Observable } from 'rxjs'
import { BusinessProfileService } from 'src/app/evida/profile/services/business-profile.service'
import { PrivateProfileService } from 'src/app/evida/profile/services/private-profile.service'
import { EvidaEvents } from 'src/app/tracking/evida-events'
import { TrackEvent } from 'src/app/tracking/simple-analytics'
import { RedirectTo } from 'src/app/utils/redirect-to'
import { AuthService } from '../../auth/auth.service'
import { TempConstants } from '../../utilities/temp.constants'

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false,
})
export class ToolbarComponent implements OnInit {
    public static readonly ELEMENT_ID = 'routerOutlet'

    public contentWidth$!: Observable<number>

    public associatedUserName: string = ''
    public isProfileDropdownOpen = false
    public installations: object | undefined

    @Input() public isLoginFlow = true
    @Input() public hideProfileSection = false // New input to control profile visibility

    @Output() dropdownStateChange = new EventEmitter<boolean>()

    constructor(
        public authService: AuthService,
        private privateProfileService: PrivateProfileService,
        private businessProfileService: BusinessProfileService
    ) {}

    @TrackEvent(EvidaEvents.Toolbar.clicks.logo)
    public onLogoClick() {
        RedirectTo.loginOrWelcomeLandingPage(this.authService.isAuthenticated)
    }

    public toggleProfileDropdown() {
        this.isProfileDropdownOpen = !this.isProfileDropdownOpen
        this.dropdownStateChange.emit(this.isProfileDropdownOpen)
    }

    private async getPrivateInstallations() {
        return await firstValueFrom(this.privateProfileService.getInstallations())
    }

    private async getBusinessInstallations() {
        return await firstValueFrom(this.businessProfileService.getInstallations())
    }

    private async getInfo() {
        if (this.authService.isAuthenticated) {
            if (this.authService.isPrivateCustomer) {
                this.installations = await this.getPrivateInstallations()
            } else {
                this.installations = await this.getBusinessInstallations()
            }
        }
        this.associatedUserName = this.authService.userName
    }

    ngOnInit() {
        this.getInfo()
        this.isProfileDropdownOpen = true
        this.dropdownStateChange.emit(this.isProfileDropdownOpen)
    }

    //temp disable termination
    public unavailable(): boolean {
        const startTime = TempConstants.TERMINATION_UNAVAILABLE_START
        const endTime = TempConstants.TERMINATION_UNAVAILABLE_END

        const now = new Date()

        return startTime <= now && now <= endTime
    }
}
